import { Component, Input } from '@angular/core';
import { SpinnerProps, spinnerStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-spinner',
  template: `<svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [ngClass]="spinner"
  >
    <g>
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10Z"
        class="spinner-bg"
      />
      <path
        d="M10 1C10 0.447717 10.4488 -0.00517752 10.9983 0.0499601C11.9691 0.147359 12.9222 0.386483 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.6135 7.07783 19.8526 8.03092 19.95 9.00166C20.0052 9.55118 19.5523 10 19 10C18.4477 10 18.0064 9.55057 17.9376 9.00259C17.8486 8.29473 17.6652 7.60043 17.391 6.93853C16.989 5.96793 16.3997 5.08601 15.6569 4.34315C14.914 3.60028 14.0321 3.011 13.0615 2.60896C12.3996 2.3348 11.7053 2.15137 10.9974 2.06242C10.4494 1.99356 10 1.55229 10 1Z"
        class="spinner-active"
      ></path>
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 10 10"
        to="360 10 10"
        dur="1s"
        repeatCount="indefinite"
      />
    </g>
  </svg>`,
})
export class SpinnerComponent {
  @Input() size: SpinnerProps['size'];
  @Input() css: SpinnerProps['css'];

  get spinner(): string[] {
    return [
      spinnerStyles({
        size: this.size,
        css: this.css,
      }).className,
    ];
  }
}
